module.exports = new __parcel__URL__("shop_machines_community_nominee_2023.e27831e6.png").toString();